import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RemoveIcon from '@mui/icons-material/Remove';

import { PERFIL_DE_FAIXAS } from '../../diagnostico/faixas';

/**
 * A faixa de saúde de um número, sempre com RÓTULO e ÍCONE.
 *
 * Cor sozinha não é acessível — 8% dos homens não distinguem verde de vermelho,
 * e o público deste produto é majoritariamente masculino e acima dos 40. Por
 * isso o chip carrega as três camadas: forma (ícone), texto (rótulo) e cor.
 *
 * O tooltip carrega a FONTE da faixa e o aviso de que ela é geral, não
 * setorial. É o que permite ao consultor discordar com argumento em vez de
 * desconfiar do produto inteiro.
 */
const ICONES = {
  excelente: <CheckCircleOutlineIcon />,
  bom: <CheckCircleOutlineIcon />,
  atencao: <WarningAmberIcon />,
  critico: <ErrorOutlineIcon />,
  ausente: <RemoveIcon />,
  semFaixa: null
};

const NivelChip = ({ nivel, rotulo, cor, fonte, size = 'small' }) => {
  if (!nivel) return null;

  const explicacao = [fonte, nivel === 'ausente' ? null : PERFIL_DE_FAIXAS.aviso]
    .filter(Boolean)
    .join(' · ');

  // A PÍLULA GANHA UM FUNDO DA PRÓPRIA COR, a 12%.
  //
  // O chip vazado nasceu para fundo claro. Sobre vidro escuro ele vira um
  // contorno fino sobre um campo que já é translúcido: duas bordas concorrendo,
  // e o rótulo sem base para assentar. Com o fundo tingido a peça vira sólida
  // sem virar berrante — e o ícone, o texto e a cor continuam os três presentes,
  // que é a regra de acessibilidade desta tela.
  const chip = (
    <Chip
      icon={ICONES[nivel] || undefined}
      label={rotulo}
      size={size}
      variant="outlined"
      color={cor === 'default' ? 'default' : cor}
      sx={{
        '& .MuiChip-icon': { fontSize: 15, ml: 0.75 },
        borderColor: cor === 'default' ? 'divider' : `${cor}.main`,
        bgcolor: (t) =>
          cor === 'default' || !t.palette[cor]
            ? 'transparent'
            : alpha(t.palette[cor].main, t.palette.mode === 'dark' ? 0.14 : 0.09)
      }}
    />
  );

  return explicacao ? <Tooltip title={explicacao}>{chip}</Tooltip> : chip;
};

export default NivelChip;
